import { FILE_ICONS, FILE_SIZE_UNITS } from '../config/jobConstants';

// Get file icon based on mime type
export const getFileIcon = (mimeType) => {
  if (mimeType.startsWith('image/')) return FILE_ICONS.IMAGE;
  if (mimeType === 'application/pdf') return FILE_ICONS.PDF;
  if (mimeType.includes('word')) return FILE_ICONS.WORD;
  if (mimeType.includes('excel') || mimeType.includes('spreadsheet')) return FILE_ICONS.EXCEL;
  return FILE_ICONS.DEFAULT;
};

// Format file size for display
export const formatFileSize = (bytes) => {
  if (bytes === 0) return '0 Bytes';
  
  const k = 1024;
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + FILE_SIZE_UNITS[i];
};